<template>
    <div class="sortTable" @click='open(Mykey.camp_id)'>
      <!-- 上部图片部分 -->
      <div class="sortTable_img">
        <img :src="Mykey.imgurl==null?'https://fview.5kjs.com/style/camp/banner/camp_img.jpg':Mykey.imgurl" alt="" @error="
            Mykey.imgurl =
              'https://fview.5kjs.com/style/camp/banner/camp_img.jpg'
          " />
      </div>
      <!-- 图下内容部分 -->
      <div class="sortTable_content">
        <div class="sortTable_content_top">
          <div class="sortTable_content_title">{{ Mykey.name }}</div>
          <div class="info_box">
            <div class="info">
              <span class="iconfont icon-users span_right"></span>
              <span> {{ Mykey.users_count }}</span>
            </div>
            <div class="info">
              <span class="iconfont icon-xiaoxi span_right"></span>
              <span>{{ Mykey.remark_count }}</span>
            </div>
          </div>
        </div>
        <div class="sortTable_content_bottom">
          <div>共有{{ Mykey.completion_num }}人完成契约</div>
          <div>完成率{{ Mykey.completion_rate }}%</div>
        </div>
      </div>
    </div>
</template>

<script>
import {mapMutations} from "vuex"
export default {
  name: "sortTable",
  props: {
    Mykey: {
      type: Object,
      default() {
        return {
          imgurl: null,
          camp_id: "9",
          name: "21天教综打卡考编特训营 (第九期)",
          users_count: 9999,
          remark_count: 9999,
          perform: 9999,
          completion_rate: "90%",
        };
      },
    },
  },
  data() {
    return {};
  },
  methods:{
    ...mapMutations(["scrollToTop"]),

    open(id){
      this.$router.push({ path: `/Detail/apply/${id}` })
      this.scrollToTop(0)
    }
  }
};
</script>

<style lang="less" scoped>
.sortTable {
  cursor: pointer;
  margin: 2.125rem 2.125rem 0 0;
  box-sizing: border-box;
  padding: 1.15625rem 1.1125rem 1.09375rem 1.1375rem;
  width: 17.5625rem;
  // height: 21.8125rem;
  background: #ffffff;
  box-shadow: 0px 0.1875rem 1rem 0px rgba(0, 0, 0, 0.08);
  //   上部图片部分
  .sortTable_img {
    // width: 15.3125rem;
    width: 100%;
    height: 10.875rem;
    img {
      width: 100%;
      height: 100%;
    }
  }
  //   图下内容部分
  .sortTable_content {
    // margin-top: 1.5rem;
    .sortTable_content_top {
      box-sizing: border-box;
      padding-top: 1.5rem;
      height: 6.75rem;
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid #ececec;
      .sortTable_content_title {
        font-size: 1rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #545e64;
      }
      .info_box {
        margin-top: 0.6875rem;
        // padding-bottom: 1.125rem;
        display: flex;
        flex-direction: row;

        .info {
          display: flex;
          align-items: center;
          padding: 0.125rem 0.625rem;
          margin-right: 0.9375rem;
          width: auto;
          height: 1.1875rem;
          background: #d0d7e0;
          border-radius: 0.1875rem;
          span {
            font-size: 0.75rem;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: #ffffff;
            text-align: center;
          }
          .span_right {
            margin-right: 0.25rem;
          }
        }
      }
    }
    .sortTable_content_bottom {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
      padding: 0 1.125rem;
      margin-top: 1.125rem;
      //   width: 15.25rem;
      width: 100%;
      height: 2.75rem;
      background: #f1f4fa;
      border-radius: 0.25rem;
      div {
        font-size: 0.875rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #4b4b5b;
      }
    }
  }
}
</style>